import React, { useContext, useState, useEffect, useMemo, useRef } from 'react';
import AppContext from '../../../App/AppContext';
import { TextBox, SecondaryButton, DialogContents, DialogTitles, Dialogs, UploadWithBadge } from '../../../Core/FormInput';
import '../../../Core/Modal/model.css';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import { DataGrid, GridOverlay } from '@material-ui/data-grid';
import { getPartReqs, getScreenDropdownPartReqID, requestPartReq } from '../../../Core/Service/partRequisitions-service';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import './TechnicianStyle.scss';
import { CustomeSignPad } from '../../../Core/SignaturePad';
import DialogComp from '../../../Core/Controls/Dialog/DialogComp';
import { isInteger, some } from 'lodash';
import { useWindowSize } from '../../../Core/Controls/ScreenResolution';
import ConfirmationModal from '../../../Core/Controls/Dialog/ConfirmationModal';
import { withStyles } from '@material-ui/core/styles';
import PartReqPhotoModal from './PartReqPhotoUploadmodal';
import InfoIcon from '@material-ui/icons/Info';
import SearchIcon from '@material-ui/icons/Search';
import PartReqOtherInfo from './RequestorApproverIssuerInfo';
import { postPhotosByPartReqID, getPartListByPartNumber } from '../../../Core/Service/partRequisitions-service';
import { IconButton, InputAdornment, Paper, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@material-ui/core';

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:hover': {
            backgroundColor: 'grey',
            color: 'white'
        },
        cursor: 'pointer'
    }
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
    head: {
        // padding: ' 5px',
        fontSize: 15,
        fontWeight: 600,
        backgroundColor: '#bdbdbd82'
    },
    body: {
        fontSize: 12
        // padding: ' 5px'
        // fontSize: 11,
    }
}))(TableCell);

const MatchingPartList = ({ list, loading, handleRowSelect }) => {
    return (
        <Paper style={{ borderRadius: '5px', maxHeight: '350px', overflow: 'auto', width: '350px' }}>
            <TableContainer>
                <Table size="small" width="550px" stickyHeader>
                    <TableHead>
                        <TableRow className="header">
                            <StyledTableCell>Number</StyledTableCell>
                            <StyledTableCell>Description</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {list?.map((j, i) => (
                            <StyledTableRow className={`row${j.isSelected ? ' is-selected-j' : ''}`} onClick={() => handleRowSelect(j)}>
                                <StyledTableCell>{j.partNumber}</StyledTableCell>
                                <StyledTableCell>{j.description}</StyledTableCell>
                            </StyledTableRow>
                        ))}
                        {list?.length === 0 && (
                            <TableRow>
                                <TableCell colSpan="4">{loading ? 'Loading...' : 'No record found.'}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

const PartRequisitionsModal = (props) => {
    const { showToast, hideTopNavAndMenu, userRoles } = useContext(AppContext);
    const urlParams = new URLSearchParams(props.location.search.toLowerCase());
    const navigateToDashboard = urlParams.get('navigate') === 'true';
    const fromStep = urlParams.get('fromstep') === 'true';
    const [windowWidths, windowHeight] = useWindowSize();

    useEffect(() => {
        fromStep && hideTopNavAndMenu();
    }, []);

    const [btnLoader, setBtnLoader] = useState({ btn1: false, btn2: false });
    const [width, height] = useWindowSize();

    const [state, setState] = useState({
        part: '',
        quantity: undefined,
        rows: [],
        partReq: [],
        isUpdate: false,
        partId: null,
        technicianJobID: null,
        createdUserID: null,
        createdUserList: [],
        wipDetails: [],
        partRequstorSignature: null,
        errors: {},
        imgPreview: false,
        signature: null,
        checkIssued: null,
        showImage: false,
        ownUser: true
    });
    const Id = props.match.params.jobId;

    const GlobalCss = withStyles({
        '@global': {
            '.MuiOutlinedInput-inputMarginDense': {
                paddingTop: '4.1px',
                paddingBottom: '4.1px'
            }
        }
    })(() => null);

    const setImgPreview = (val, data = null, date) => {
        setState((st) => ({ ...st, imgPreview: val, signature: data, sigDate: date }));
    };

    const changeQantity = (id, des, name) => (e) => {
        let changedArray = [...state.rows];
        let objIndex = state.rows.findIndex((x) => x.id === id);
        changedArray[objIndex][name] = e.target.value;
        setState((st) => ({
            ...st,
            rows: changedArray
        }));
    };
    const onChangeCheckbox = (id, des, name) => (e) => {
        let changedArray = [...state.rows];
        let objIndex = changedArray.findIndex((x) => x.id === id);

        changedArray[objIndex][name] = e.target.checked;

        setState((st) => ({
            ...st,
            rows: changedArray
        }));
    };

    const onImagemodalClose = (res) => {
        setState((st) => ({ ...st, showImage: false, partId: null, desc: '' }));
        makeEmptyPhotos('oldPhoto');
        res && pullWorkflowAndUpdateState(state.createdUserID);
    };
    const [data, setData] = useState({ showInfo: false });
    const setShowInfo = (val) => {
        if (val.requestor) {
            setData((st) => ({
                ...st,
                showInfo: true,
                requestor: val.requestor,
                requestorSign: val.requestorSignature,
                requestorDate: val.requestedTime,
                issuer: val.issuer,
                issuerSign: val.issuerSignature,
                issuerDate: val.issuedTime,
                approver: val.approver,
                approverSign: val.approverSignature,
                approverDate: val.approvedTime
            }));
        }
    };

    const columns = [
        {
            field: 'partReqPartNumber',
            headerName: 'Part Number',
            width: 302,
            renderCell: (params) => {
                return (
                    <input
                        name="partReqPartNumber"
                        id="partReqPartNumber"
                        data-rowid={params.row.id}
                        // onChange={onIssueQtyChange}
                        onChange={changeQantity(params.row.id, params.row.partReqPartNumber, 'partReqPartNumber')}
                        value={params.value}
                        className="pa-4"
                        disabled={!state.ownUser}
                    />
                );
            }
        },
        {
            field: 'partReqPartDescription',
            headerName: 'Parts',
            flex: 0.2,
            renderCell: (params) => {
                return (
                    <input
                        name="desc"
                        id="desc"
                        data-rowid={params.row.id}
                        // onChange={onIssueQtyChange}
                        onChange={changeQantity(params.row.id, params.row.partReqPartDescription, 'partReqPartDescription')}
                        value={params.value}
                        className="pa-4"
                        disabled={!state.ownUser}
                    />
                );
            }
        },
        {
            field: 'partReqQuantity',
            headerName: 'Qty',
            width: 250,
            renderCell: (params) => {
                return (
                    <div style={{ position: 'relative', width: '100%' }}>
                        {!params.row.partReqQuantity && <span style={{ position: 'absolute', top: -11, right: -5, color: 'red' }}>*</span>}
                        <input
                            name="desc"
                            id="desc"
                            data-rowid={params.row.id}
                            onChange={changeQantity(params.row.id, params.row.partReqQuantity, 'partReqQuantity')}
                            value={params.value}
                            className="pa-4"
                            disabled={!state.ownUser}
                        />
                    </div>
                );
            }
        },
        {
            field: 'isFitted',
            headerName: 'Fitted',
            width: 230,
            renderCell: (params) => {
                return (
                    <div style={{ alignItems: 'left' }}>
                        <input
                            type="checkbox"
                            name="isFitted"
                            id="isFitted"
                            data-rowid={params.row.id}
                            // onChange={onIssueQtyChange}
                            onClick={onChangeCheckbox(params.row.id, params.row.isFitted, 'isFitted')}
                            // value={params.value}
                            //className="pa-4"
                            disabled={!state.ownUser}
                            checked={params.row.isFitted}
                        />
                    </div>
                );
            }
        },
        { field: 'issueStatus', headerName: 'Issue Status', width: 230 },
        {
            field: '',
            headerName: '',
            width: 140,
            sortable: false,
            renderCell: (params) => (
                <div style={{ margin: '20px 0px 0px 9px', cursor: `${params.row.photosUploaded >= 0 ? 'pointer' : ''}` }}>
                    <UploadWithBadge
                        state={params.row.photosUploaded > 0 || 0}
                        count={params.row.photosUploaded || 0}
                        onClick={() =>
                            params.row.photosUploaded >= 0 &&
                            setState((st) => ({ ...st, partId: params.row.id, desc: params.row.partReqPartDescription, showImage: true }))
                        }
                    />
                    <InfoIcon disabled={!state.ownUser} className="doneIcon" onClick={() => setShowInfo(params.row)} />
                </div>
            )
        }
    ];

    const isTechnician = userRoles.includes('technician');
    const isAuditor = userRoles.includes('auditor');

    const new_columns = useMemo(() => {
        const tempCols = [...columns];
        if (state.checkIssued) {
            tempCols.splice(0, 2, { field: 'qnIssued', headerName: 'Issued', width: 140 });
        }
        return tempCols;
    }, [columns]);

    const technicianJobId = props.match.params?.technicianJobId;

    useEffect(async () => {
        setState((st) => ({
            ...st,
            technicianJobID: technicianJobId
        }));
        getScreenDropdown();
    }, [technicianJobId]);

    const TechBtnClick = (val) => {
        setState((st) => ({
            ...st,
            technicianJobID: val.technicianJobID,
            createdUserID: val.createdUserID,
            ownUser: val.ownUser == 'Y'
        }));
        pullWorkflowAndUpdateState(val.createdUserID);
    };
    const getScreenDropdown = async () => {
        let result = await getScreenDropdownPartReqID(Id, state.createdUserID, 'R');
        setState((st) => {
            const nst = { ...st };
            //   nst.stockList = ops1;
            //   nst.statusList = ops;
            nst.wipDetails = result.data.wipDetails[0];
            nst.createdUserList = result.data.technician;
            if (st.createdUserID == null) {
                nst.createdUserID = result.data.technician[0]?.createdUserID;
                nst.technicianJobID = result.data.technician[0]?.technicianJobID;
                nst.createdUserID = result.data.technician[0]?.createdUserID;
                nst.ownUser = result.data.technician[0]?.ownUser == 'Y';
            }
            pullWorkflowAndUpdateState(result.data.technician[0]?.createdUserID);
            return nst;
        });
    };
    const pullWorkflowAndUpdateState = async (createdUserID) => {
        let result = await getPartReqs(Id, createdUserID, 'R', state.technicianJobID);
        const Result = result.data?.partReqs?.map((row) => ({
            id: row.partReqID,
            partReqPartDescription: row.partReqPartDescription,
            partReqQuantity: row.partReqQuantity,
            isDeleted: false,
            disabled: row.issuerSignature && row.approverSignature,
            isApproved: row.isApproved,
            qnIssued: row.partReqIssuedQuantity,
            requestor: row.requestor,
            approver: row.approver,
            partReqStatusDescription: row.partReqStatusDescription,
            issuer: row.issuer,
            issueStatus: row.issueStatus,
            requestorSignature: row.requestorSignature,
            issuerSignature: row.issuerSignature,
            approverSignature: row.approverSignature,
            partReqId: row.partReqID,
            requestedTime: row.requestedTime,
            issuedTime: row.issuedTime,
            approvedTime: row.approvedTime,
            photosUploaded: row.photosUploaded,
            isFitted: row.isFitted,
            partReqPartNumber: row.partReqPartNumber,
            Photos: [],
            oldPhoto: []
        }));
        if (result.success) {
            setState((st) => {
                let newSt = { ...st };
                // if (st.createdUserID == null) {
                //     newSt.createdUserID = result.data.technician[0]?.createdUserID;
                //     newSt.technicianJobID = result.data.technician[0]?.technicianJobID;
                //     newSt.createdUserID = result.data.technician[0]?.createdUserID;
                //     newSt.ownUser = result.data.technician[0]?.ownUser == 'Y';
                // }
                newSt.rows = Result;
                // newSt.createdUserList = result.data?.technician;
                // newSt.wipDetails = result.data?.wipDetails[0];
                newSt.checkIssued = some(result.data.partReqs, (r) => r.qnIssued);

                return newSt;
            });
            // setState((st) => ({
            //     ...st,
            //     rows: Result,
            //     createdUserList: result.data?.technician,
            //     wipDetails: result.data?.wipDetails[0],
            //     checkIssued: some(result.data.partReqs, (r) => r.qnIssued)
            //     //createdUserID: result.data.technician[0]?.createdUserID
            //     // partRequstorSignature: result.data.partReqs[0]?.partRequstorSignature
            // }));
        }
        if (!result.success) {
            showToast(result.message);
        }
    };

    const addPartToLocally = () => {
        if (state.quantity === null) {
            showToast('Quantity is required');
        } else {
            let newPartToAdd = {
                partReqPartDescription: state.part,
                partReqQuantity: state.quantity,
                partReqPartNumber: state.partReqPartNumber,
                qnIssued: '-',
                isDeleted: +state.quantity === 0,
                ...(state.partId && { partReqId: state.partId || null })
            };
            setState((st) => ({
                ...st,
                rows: state.rows.filter((item) => item.id !== state.partId)
            }));
            setState((st) => {
                newPartToAdd.id = st.rows.length === 0 ? 1 : Math.max(...st.rows.map((c) => c.id)) + 1;
                return {
                    ...st,
                    rows: [...st.rows, newPartToAdd],
                    part: '',
                    quantity: '',
                    partReqPartNumber: '',
                    isUpdate: false,
                    partId: undefined
                };
            });
        }
    };

    const validations = (mode) => {
        const { partRequstorSignature } = state;
        let formIsValid = true;
        let errors = {};

        if (!partRequstorSignature) {
            errors.partRequstorSignature = 'Signature is required';
            formIsValid = false;
        }

        setState((st) => ({ ...st, errors: errors }));
        return formIsValid;
    };

    const handelAddPartToServer = async (mode) => {
        if (isTechnician) {
            if (state.rows?.length > 0) {
                addPart(mode);
            } else {
                showToast('Please add least one part');
            }
        } else {
            addPart(mode);
        }
    };
    const addPart = async (mode) => {
        mode == 'save' ? setBtnLoader((st) => ({ ...st, btn2: true })) : setBtnLoader((st) => ({ ...st, btn1: true }));
        const data = {
            partRequstorSignature: state.partRequstorSignature,
            partReqsAddVM: state.rows.map((c) => ({
                partReqQuantity: c.partReqQuantity,
                partReqPartDescription: c.partReqPartDescription,
                isDeleted: c.isDeleted,
                partReqId: c.partReqId,
                isFitted: c.isFitted,
                partReqPartNumber: c.partReqPartNumber
            })),
            mode: mode
        };
        let res1 = await postPhotosByPartReqID(state.rows);
        let res = await requestPartReq(Id, data, state.createdUserID, state.technicianJobID);
        if (!res.success) {
            console.error(res);
        }
        showToast(res.message);
        if (res.success && fromStep) {
            mode == 'save' ? setBtnLoader((st) => ({ ...st, btn2: false })) : setBtnLoader((st) => ({ ...st, btn1: false }));
            setTimeout(() => {
                window.top.postMessage({ type: navigateToDashboard ? 'navigate-dashboard' : 'close-modal' }, '*');
            }, 1000);
        }
    };

    const showConfirmationModal = () => {
        if (validations()) {
            setState((st) => ({ ...st, showConfirmModal: true }));
        }
    };

    const fieldChange = (e) => {
        const { name, value } = e.target;
        setState((st) => {
            return { ...st, [name]: value };
        });
    };

    const signChange = (e) => {
        setState((st) => {
            return { ...st, ...e };
        });
    };

    const clearSig = (val) => {
        setState((st) => ({
            ...st,
            partRequstorSignature: null
        }));
    };

    function CustomNoRowsOverlay() {
        return (
            <GridOverlay>
                <div>No parts available</div>
            </GridOverlay>
        );
    }

    const gridheight = `calc(100vh - ${isTechnician ? '348px' : '274px'})`;

    const inputFile = useRef(null);

    const upload = async (e) => {
        const files = Array.from(e.target.files);

        files.map((file) => {
            const reader = new FileReader();
            reader.readAsText(file);

            reader.onload = () => {
                const res = reader.result.split('\n');
                res.splice(0, 1);

                res.map((row) => {
                    const parts = row.split('|');

                    const partDesc = parts[0] + ' - ' + parts[1] + ' - ' + parts[5];
                    const quantity = parts[2];

                    if (row == '' || quantity == '') return;

                    let newPartToAdd = {
                        partReqPartDescription: partDesc,
                        partReqQuantity: quantity % 1 == 0 ? Math.trunc(quantity) : quantity,
                        qnIssued: '-'
                    };

                    setState((st) => {
                        newPartToAdd.id = st.rows.length === 0 ? 1 : Math.max(...st.rows.map((c) => c.id)) + 1;
                        return {
                            ...st,
                            rows: [...st.rows, newPartToAdd],
                            part: '',
                            quantity: '',
                            isUpdate: false,
                            partId: undefined
                        };
                    });
                });
            };

            reader.onerror = () => {
                console.log('Error reading .xfr File');
            };
        });
    };

    const makeEmptyPhotos = (name) => {
        let changedArray = [...state.rows];
        let objIndex = state.rows.findIndex((x) => x.partReqId === state.partId);
        changedArray[objIndex][name] = [];
        setState((st) => ({ ...st, rows: changedArray }));
    };
    const setPhotos = (name) => {
        setState((st) => ({ ...st, name }));
    };
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorE2, setAnchorE2] = React.useState(null);

    const handleRowSelect = (params) => {
        setState((st) => {
            const nst = {
                ...st,
                id: null,
                partReqPartNumber: params.partNumber,
                // quantity: params.quantity,
                part: params.description,
                partId: null,
                loading: false,
                matchingPartNumber: [],
                focus: true
            };
            return nst;
        });

        setAnchorEl(null);
        setAnchorE2(null);
    };

    const pullDataByPartNumber = async (e, type) => {
        let res;
        if (type == 'P') {
            // if (state.partReqPartNumber) {
            setAnchorEl(e.currentTarget);
            res = await getPartListByPartNumber(state.partReqPartNumber, null);
            if (res.success) {
                setState((st) => ({ ...st, matchingPartNumber: res.data.partDetails, loading: false }));
            }
            // } else {
            //     showToast('Please enter part number to fetch data');
            // }
        } else {
            // if (state.part) {
            setAnchorE2(e.currentTarget);
            res = await getPartListByPartNumber(null, state.part);
            if (res.success) {
                setState((st) => ({ ...st, matchingPartNumber: res.data.partDetails, loading: false }));
            }
            // }
            // else {
            //     showToast('Please enter description to fetch data');
            // }
        }
    };
    const handlePoperClose = () => {
        setAnchorEl(null);
        setAnchorE2(null);
    };

    const open = Boolean(anchorEl);
    const open2 = Boolean(anchorE2);
    const id = open ? 'simple-popover' : undefined;
    const id2 = open2 ? 'simple-popover2' : undefined;
    return (
        <div style={{ maxWidth: '100%' }}>
            <GlobalCss />
            {!fromStep && (
                <Breadcrumbs separator=">>" aria-label="breadcrumb">
                    <Link color="inherit" to={'/'}>
                        Technician App
                    </Link>
                    <Typography color="secondary" style={{ fontSize: '0.85rem' }}>
                        Part Requisitions
                    </Typography>
                </Breadcrumbs>
            )}
            <DialogTitles>
                <Grid container spacing={2}>
                    {state.createdUserList.map((m) => (
                        <div className="tech-btn-group">
                            <Button className={state.createdUserID == m.createdUserID ? 'active-btn' : 'all-btn'} onClick={() => TechBtnClick(m)}>
                                {m.requestor}
                            </Button>
                        </div>
                    ))}
                </Grid>
            </DialogTitles>
            <DialogContents>
                <Grid container spacing={1}>
                    {data.showInfo && <PartReqOtherInfo data={data} onClose={() => setData((st) => ({ ...st, showInfo: false }))} />}
                    {state.showImage && (
                        <DialogComp title="Image Upload" onClose={() => onImagemodalClose(false)} fullWidth maxWidth="lg">
                            <PartReqPhotoModal
                                partId={state.partId}
                                onFormSubmit={() => pullWorkflowAndUpdateState()}
                                desc={state.desc}
                                onClose={onImagemodalClose}
                                onImageChange={setPhotos}
                                rows={state.rows}
                            />
                        </DialogComp>
                    )}
                    {state.imgPreview ? (
                        <DialogComp title="Signature" onClose={() => setImgPreview(false)} fullWidth maxWidth="md">
                            <div style={{ position: 'relative' }}>
                                <div style={{ position: 'absolute', bottom: 10, right: 0 }}>{state.sigDate}</div>
                                <img src={state.signature} alt={'stamp'} width="500" height="300" />
                            </div>
                        </DialogComp>
                    ) : null}
                    <Grid item xs={12} sm={8} style={{ fontSize: 21, textAlign: 'left' }}>
                        Registration Number:&nbsp; <b> {state.wipDetails?.registration}</b> &nbsp; WIP No:&nbsp; <b> {state.wipDetails?.wipNumber}</b>
                    </Grid>
                    {state.ownUser ? (
                        <>
                            <Grid item xs={4} sm={2}>
                                <SecondaryButton isBtnLoader={btnLoader.btn2} onClick={() => handelAddPartToServer('save')} className="setFullWidth">
                                    Save
                                </SecondaryButton>
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <SecondaryButton isBtnLoader={btnLoader.btn1} onClick={showConfirmationModal} className="setFullWidth">
                                    Submit
                                </SecondaryButton>
                            </Grid>
                            <Grid item container spacing={1} alignItems="flex-end">
                                <Grid item xs={12} sm={2}>
                                    <FormLabel component="legend">Part Number</FormLabel>
                                    <TextBox
                                        onChange={fieldChange}
                                        value={state.partReqPartNumber}
                                        name="partReqPartNumber"
                                        autoFocus={true}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Tooltip title={'Fetch Part Details By Number'} arrow>
                                                        <Grid>
                                                            <IconButton style={{ padding: '0px' }} onClick={(e) => pullDataByPartNumber(e, 'P')} size="small">
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </Grid>
                                                    </Tooltip>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Popover
                                    open={open}
                                    id="simple-popover"
                                    anchorEl={anchorEl}
                                    autoFocus={true}
                                    onClose={handlePoperClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center'
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left'
                                    }}
                                    style={{ left: '-267px' }}
                                >
                                    <MatchingPartList list={state.matchingPartNumber || []} loading={state.loading} handleRowSelect={handleRowSelect} />
                                </Popover>
                                <Grid item xs={12} sm={4}>
                                    <FormLabel component="legend">Part Description</FormLabel>
                                    <TextBox
                                        onChange={fieldChange}
                                        value={state.part}
                                        name="part"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Tooltip title={'Fetch Part Details By Description'} arrow>
                                                        <Grid>
                                                            <IconButton style={{ padding: '0px' }} onClick={(e) => pullDataByPartNumber(e, 'D')} size="small">
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </Grid>
                                                    </Tooltip>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Popover
                                    open={open2}
                                    id="simple-popover2"
                                    anchorEl={anchorE2}
                                    onClose={handlePoperClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left'
                                    }}
                                    style={{ left: '-556px' }}
                                >
                                    <MatchingPartList list={state.matchingPartNumber || []} loading={state.loading} handleRowSelect={handleRowSelect} />
                                </Popover>

                                <Grid item xs={2} sm={2}>
                                    <FormLabel component="legend">Quantity</FormLabel>
                                    <TextBox type="number" onChange={fieldChange} value={state.quantity} name="quantity" />
                                </Grid>
                                <Grid item xs={12} sm={2} className="add-btn-container">
                                    <SecondaryButton
                                        onClick={addPartToLocally}
                                        className="setFullWidth"
                                        disabled={state.isUpdate === false && state.quantity === '0'}
                                    >
                                        Add
                                    </SecondaryButton>
                                </Grid>
                                <Grid item xs={2} sm={2} className="add-btn-container">
                                    <input
                                        name="xfrFile"
                                        multiple
                                        type="file"
                                        onChange={(e) => upload(e)}
                                        style={{ display: 'none' }}
                                        accept=".xfr"
                                        ref={inputFile}
                                    />
                                    <SecondaryButton className="setFullWidth" onClick={() => inputFile.current.click()}>
                                        Import Shopping List
                                    </SecondaryButton>
                                </Grid>
                            </Grid>
                        </>
                    ) : null}
                    <div
                        style={{
                            height: `${windowHeight < 400 ? '400px' : gridheight}`,
                            width: '100%'
                        }}
                    >
                        <DataGrid
                            className="data-grid-container"
                            components={{
                                NoRowsOverlay: CustomNoRowsOverlay
                            }}
                            headerHeight={50}
                            rowHeight={50}
                            hideFooter={true}
                            columns={new_columns}
                            rows={state.rows.filter((item) => item.isDeleted !== true)}
                            disableColumnMenu={true}
                            showColumnRightBorder={true}
                            pageSize={100}
                        />
                    </div>
                </Grid>
                {!isAuditor && (
                    <Grid item xs={12} sm={6} style={{ marginTop: 8 }}>
                        <CustomeSignPad
                            onChange={signChange}
                            clearSig={clearSig}
                            content={'Requestor Signature'}
                            sign={state.technicianSignature}
                            name="partRequstorSignature"
                        />
                        <span className="mandatoryfields">{state.errors['partRequstorSignature']}</span>
                    </Grid>
                )}
            </DialogContents>
            {state.showConfirmModal ? (
                <DialogComp title="Part Requisitions" onClose={() => setState((st) => ({ ...st, showConfirmModal: false }))} maxWidth="sm">
                    <ConfirmationModal
                        message={`By submitting you will not be able to make any further changes to the form. If you need to make further changes please click cancel and select the save option.`}
                        handleSubmit={() => handelAddPartToServer('submit')}
                        handleCancel={() => setState((st) => ({ ...st, showConfirmModal: false }))}
                    />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default PartRequisitionsModal;
